<template>
    <trusteeship-dialog
        v-if="visible"
        :open="visible"
        mode="confirm"
        :platform-name="platformName"
        :loading="loading"
        :reject-loading="rejectLoading"
        @agree="handleAgree"
        @reject="handleReject"
        @dismiss="handleDismiss"
    />
</template>

<script>
/**
 * @file trusteeship-confirm.vue
 * @desc 律师端-托管授权确认弹窗，登录后存在待确认申请时弹出
 */
import TrusteeshipDialog from './trusteeship-dialog.vue';
import {getTrusteePopup, confirmTrustee, dismissTrustee} from './api';

export default {
    name: 'TrusteeshipConfirm',
    components: {
        'trusteeship-dialog': TrusteeshipDialog
    },
    data() {
        return {
            visible: false,
            loading: false,
            rejectLoading: false,
            id: '',
            platformName: ''
        };
    },
    mounted() {
        this.fetchPopup();
    },
    methods: {
        // 查询托管弹窗状态
        fetchPopup() {
            getTrusteePopup().then(res => {
                const data = res && +res.code === 0 ? res.data : null;
                // is_bind=2（申请绑定待确认）且 need_popup 时弹出授权确认弹窗
                if (data && Number(data.is_bind) === 2 && data.need_popup && data.id) {
                    this.id = data.id;
                    this.platformName = data.platform_name || '';
                    this.visible = true;
                }
            }).catch(() => {});
        },
        // 同意 / 拒绝授权
        submitConfirm(agree) {
            if (this.loading || this.rejectLoading) {
                return;
            }
            // 授权与拒绝各自维护 loading
            const key = agree === 1 ? 'loading' : 'rejectLoading';
            this[key] = true;
            confirmTrustee(this.id, agree).then(res => {
                if (res && +res.code === 0) {
                    this.visible = false;
                    if (agree === 1) {
                        this.$Message.success('已授权托管');
                        this.goConsult();
                    }
                }
                else {
                    this.$Message.error(res && res.msg || '操作失败，请重试');
                }
            }).catch(() => {
                this.$Message.error('操作失败，请重试');
            }).finally(() => {
                this[key] = false;
            });
        },
        // 授权托管
        handleAgree() {
            this.submitConfirm(1);
        },
        // 拒绝托管
        handleReject() {
            this.submitConfirm(0);
        },
        // 授权成功后跳转到1v1咨询页，已在该页则不跳转
        goConsult() {
            if (this.$route.name === 'consult') {
                return;
            }
            this.$router.push({name: 'consult'});
        },
        // 关闭（当天不再展示）
        handleDismiss() {
            this.visible = false;
            dismissTrustee().catch(() => {});
        }
    }
};
</script>
